import { createSlice } from '@reduxjs/toolkit';
import { createPassenger, getPassengers, updatePassengerById } from './operations';
import { deletePassengersById } from './operations/deletePassengersById';

const handlePending = state => {
  state.status = 'pending';
  state.error = null;
};
const handleRejected = (state, action, status = 'rejected') => {
  state.status = status;
  state.error = action.payload;
};
const handleFulfilled = (state, status = 'fulfilled') => {
  state.status = status;
  state.error = null;
};

const initialState = {};

export const passengersSlice = createSlice({
  name: 'passengers',
  initialState,
  reducers: {
    setGenerateTicketsData: (state, action) => { state.generateTicketsData = action.payload; },
    setGeneratePassengersList: (state, action) => { state.generatePassengersList = action.payload; }
  },
  extraReducers: (builder) =>
    builder
      .addCase(createPassenger.pending, (state, action) => { handlePending(state); })
      .addCase(createPassenger.rejected, (state, action) => { handleRejected(state, action); })
      .addCase(createPassenger.fulfilled, (state, action) => { handleFulfilled(state, "added");
        state.list = action.payload?.concat(state.list);
        state.total = state.total ? state.total + (action.payload?.length || 1) : 1;
      })
      .addCase(getPassengers.pending, (state, action) => { handlePending(state); })
      .addCase(getPassengers.rejected, (state, action) => { handleRejected(state, action); })
      .addCase(getPassengers.fulfilled, (state, action) => { handleFulfilled(state);
        state.list = action.payload.list;
        state.total = action.payload.total;
        state.totalTickets = action.payload.totalTickets;
      })
      .addCase(updatePassengerById.pending, (state, action) => { handlePending(state); })
      .addCase(updatePassengerById.rejected, (state, action) => { handleRejected(state, action); })
      .addCase(updatePassengerById.fulfilled, (state, action) => { handleFulfilled(state, "updated");
        state.list = action.payload?.reduce((acc, passenger) => {
          // Перевіряємо, чи є пасажир з таким passenger_id в поточному state.list
          const existingPassengerIndex = acc.findIndex( (p) => p?.passenger_id === passenger?.passenger_id );
        
          if (existingPassengerIndex !== -1) {
            // Якщо пасажир знайдений, оновлюємо його
            acc[existingPassengerIndex] = passenger;
          } else {
            // Якщо пасажир не знайдений, додаємо його на початок
            acc.unshift(passenger);
            state.total = state.total + 1;
          }
        
          return acc;
        }, [...state.list]); // Використовуємо копію поточного state.list
      })
      .addCase(deletePassengersById.pending, (state, action) => { handlePending(state); })
      .addCase(deletePassengersById.rejected, (state, action) => { handleRejected(state, action); })
      .addCase(deletePassengersById.fulfilled, (state, action) => { handleFulfilled(state);
        state.list = state.list?.filter(i => !action.payload?.list?.includes(i?.passenger_id));
        state.total = action.payload.total;
      })
});

export const { setGenerateTicketsData, setGeneratePassengersList } = passengersSlice.actions;
export const passengersReducer = passengersSlice.reducer;
